module.exports = __webpack_public_path__ + "static/posts-tablet-981f0b4446b6692eaae3fc0ec780773a.png";